"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadOptInStatus = exports.FetchOptInStatus = exports.FetchOptInStatusActionTypes = exports.OptInActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _createAction = _interopRequireDefault(require("flux-actions/createAction"));

var _actions = require("settings-ui-lib/utils/actions");

var OptInActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_OPT_IN_STATUS: null
}, 'shared');
exports.OptInActionTypes = OptInActionTypes;
var FetchOptInStatusActionTypes = (0, _actions.createRequestTypes)(OptInActionTypes.FETCH_OPT_IN_STATUS);
exports.FetchOptInStatusActionTypes = FetchOptInStatusActionTypes;
var FetchOptInStatus = (0, _actions.createRequestActions)(FetchOptInStatusActionTypes);
exports.FetchOptInStatus = FetchOptInStatus;
var loadOptInStatus = (0, _createAction.default)(OptInActionTypes.FETCH_OPT_IN_STATUS);
exports.loadOptInStatus = loadOptInStatus;